export default from './ScrollProgress'


// WEBPACK FOOTER //
// ./src/components/ScrollProgress/index.js